/**
 * Crypto config
 */

const MIN_ASYMMETRIC_KEY_SIZE_BITS = 2048;

/**
 * Get the minimum acceptable assymetric key size
 * @return {Number} Size in bits
 */
module.exports.getMinAsymmetricKeySizeBits = function () {
  return MIN_ASYMMETRIC_KEY_SIZE_BITS;
};
